<template>
  <div>
    <div class="navigator-bar">
      {{ this.form.id === 1 ? '编辑员工' : '添加员工' }}
      <el-button @click="$router.back()" size="small">返回</el-button>
    </div>

    <div class="container">
      <el-form :model="form" :rules="rules" label-position="right" label-width="80px" ref="form" style="width: 360px">
        <el-form-item label="员工名">
          <el-input placeholder="请输入员工名" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input placeholder="请输入员工手机号" v-model="form.mobile"></el-input>
        </el-form-item>
        <el-form-item label="选择角色">
          <el-select placeholder="请选择" size="large" style="width: 100%" v-model="form.storeroleid">
            <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in roleOptions"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="具备权限">
          <div :key="item" v-for="item in rolePermissions">{{ item }}</div>
        </el-form-item>
      </el-form>
    </div>

    <div style="text-align: right;padding: 24px;">
      <el-button v-if="this.form.id" @click="update" size="small" type="primary">更新</el-button>
      <el-button v-if="!this.form.id" @click="create" size="small" type="primary">添加</el-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Tab from '../../components/tab/index.vue';
import { M } from '../../service/grpc.js';
import { rpc } from '../../service/index.js';
import { getToken } from '../../service/helper.js';

export default {
  name: 'EmployeeEdit',
  data() {
    return {
      form: {
        id: 0,
        name: '',
        mobile: '',
        storeroleid: 0
      },
      roleOptions: [],
      rolePermissions: [],
      rules: {
        name: [{ required: true, message: '请输入员工名', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入员工联系方式', trigger: 'blur' }],
        storeroleid: [{ required: true }]
      }
    };
  },
  watch: {
    'form.storeroleid': function(v) {
      const that = this.roleOptions.find(i => i.id === v);
      this.rolePermissions = that.cansList;
    }
  },
  async mounted() {
    this.token = getToken();
    const res = await rpc(
      'StoreStoreRoleService.GetStoreRoleList',
      M('StoreRoleListQueryRequest', {
        token: M('Token', { token: this.token }),
        count: 100
      })
    );
    this.roleOptions = res.storerolelistList;
    if (res.storerolelistList.length) {
      this.form.storeroleid = res.storerolelistList[0].id;
    }
    if (this.$route.query.id) {
      rpc('StoreStoreAdminService.GetStoreAdmin', M('IDWithTokenRequest', { token: M('Token', { token: this.token }), id: this.$route.query.id })).then(res => {
        this.form = res;
      });
    }
  },
  methods: {
    create() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const res = await rpc('StoreStoreAdminService.CreateStoreAdmin', M('StoreAdminWithTokenRequest', { token: M('Token', { token: this.token }), storeadmin: M('StoreAdmin', this.form) }));
          this.$router.back();
          this.$message({
            message: '保存成功',
            type: 'success'
          });
        }
      });
    },
    update() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const res = await rpc('StoreStoreAdminService.UpdateStoreAdmin', M('StoreAdminWithTokenRequest', { token: M('Token', { token: this.token }), storeadmin: M('StoreAdmin', this.form) }));
          this.$router.back();
          this.$message({
            message: '保存成功',
            type: 'success'
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.navigator-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  color: #999;
  margin-top: 18px;
}
</style>
